import type { QueryClient } from '@tanstack/react-query';
import { registerSessionRetirement } from '@cdf/api-client-react';

/** Both cache owners join the synchronous boundary, including same-account login. */
export function registerSessionQueryClient(client: QueryClient): () => void {
  return registerSessionRetirement(() => {
    void client.cancelQueries();
    client.clear();
  });
}
